module.exports = __webpack_public_path__ + "static/media/star.91fc85c3.png";